var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { "padding-top": "0px" },
      attrs: { id: "main-container", fluid: "", "fill-height": "" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.submitForm($event)
        }
      }
    },
    [
      _c(
        "v-layout",
        { attrs: { flex: "", "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm5: "", md5: "", lg5: "", xl3: "" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _vm.isUserForm
                    ? _c("v-text-field", {
                        attrs: {
                          label: "Username",
                          rules: _vm.userNameRules,
                          placeholder: " ",
                          required: ""
                        },
                        model: {
                          value: _vm.loginVm.username,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.loginVm,
                              "username",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "loginVm.username"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Password",
                      type: "password",
                      rules: _vm.passwordRules,
                      placeholder: " ",
                      required: ""
                    },
                    model: {
                      value: _vm.loginVm.password,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.loginVm,
                          "password",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginVm.password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { flex: "", "align-end": "", "justify-end": "" } },
                    [
                      _c("v-flex", {
                        staticStyle: { "text-align": "right" },
                        attrs: { xs6: "", md6: "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        flex: "",
                        "align-center": "",
                        "justify-center": ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          staticStyle: { "flex-basis": "0" },
                          attrs: { xs6: "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "form-submit-button",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.submitForm($event)
                                }
                              }
                            },
                            [_vm._v("\n              Anmelden\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }